import { Injectable } from '@angular/core';
import { URL as ENV_URL } from '../../../environments/environment';
import { RACKEO_SITE } from '../rackeo-site';
import { RackeoCartConfig, RackeoLocaleService } from './locale.service';

interface RackeoCartPlan {
  pid: number;
  cartPid?: number;
}

@Injectable({
  providedIn: 'root'
})
export class RackeoCartService {
  constructor(private readonly locale: RackeoLocaleService) {}

  get symbol(): string {
    return this.config.symbol;
  }

  get currencyHint(): string {
    return this.config.currencyHint;
  }

  buildProductUrl(plan: RackeoCartPlan): string {
    const pid = plan.cartPid ?? plan.pid;

    return this.buildUrl({
      a: 'add',
      pid: String(pid),
      currency: String(this.config.currency),
      tld: this.config.tld
    });
  }

  buildCommercialDomainUrl(mode: 'register' | 'transfer'): string {
    return this.buildUrl({
      a: 'add',
      domain: mode,
      currency: String(this.config.currency),
      tld: '.com'
    });
  }

  get countryRegisterDomainUrl(): string {
    return RACKEO_SITE.domainRegisterUrl;
  }

  private get config(): RackeoCartConfig {
    const content = this.locale.getContentSnapshot();

    if (!content?.cart) {
      throw new Error('Rackeo cart config is missing.');
    }

    return content.cart;
  }

  private buildUrl(params: Record<string, string>): string {
    const url = new globalThis.URL(ENV_URL.RACKEO_CART);

    url.search = '';

    Object.entries(params).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    return url.toString();
  }
}
